module.exports = __webpack_public_path__ + "media/svg-new/form-2-37fec8cc.svg";